import { createAsyncThunk } from "@reduxjs/toolkit";
import overallReportingApi from "app/api/overallReporting";

// Get Opening Balance
export const getOpeningBalance = createAsyncThunk(
  "reporting/getOpeningBalance",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getOpeningBalance(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Allocated Credits
export const getAllocatedCredits = createAsyncThunk(
  "reporting/getAllocatedCredits",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getAllocatedCredits(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Credits Used
export const getCreditsUsed = createAsyncThunk(
  "reporting/getCreditsUsed",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getCreditsUsed(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Credits Reimbursed
export const getCreditsReimbursed = createAsyncThunk(
  "reporting/getCreditsReimbursed",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getCreditsReimbursed(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Closing Balance
export const getClosingBalance = createAsyncThunk(
  "reporting/getClosingBalance",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getClosingBalance(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Eligible Rollover
export const getEligibleRollover = createAsyncThunk(
  "reporting/getEligibleRollover",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getEligibleRollover(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Total Print Jobs
export const getTotalPrintJobs = createAsyncThunk(
  "reporting/getTotalPrintJobs",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getTotalPrintJobs(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Utilization Rate
export const getUtilizationRate = createAsyncThunk(
  "reporting/getUtilizationRate",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getUtilizationRate(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Monthly Credit Usage
export const getMonthlyCreditUsage = createAsyncThunk(
  "reporting/getMonthlyCreditUsage",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getMonthlyCreditUsage(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Credits Used vs Reimbursed
export const getCreditsUsedVsReimbursed = createAsyncThunk(
  "reporting/getCreditsUsedVsReimbursed",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getCreditsUsedVsReimbursed(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Printed vs Requested Quantity
export const getPrintedVsRequestedQuantity = createAsyncThunk(
  "reporting/getPrintedVsRequestedQuantity",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getPrintedVsRequestedQuantity(payload)
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);
